// External Dependencies:
import React from 'react'
import { v4 as uuidv4 } from 'uuid'

// Internal Dependencies:
import LoadScript from 'containers/LoadScript'

class Place extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			value: props.value,
			placeData: {
				suburb: '',
				postcode: '',
				state: ''
			}
		}

		this.uid = uuidv4()
	}

	static defaultProps = {
		type: 'text',
		label: false,
		focus: false
	}

	componentDidMount() {
		if ( this.props.focus ) {
			this.input.focus()
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( this.props.focus ) {
			this.input.focus()
		}
	}

	handleScriptLoad = () => {
		this.autocomplete = new google.maps.places.Autocomplete(
			this.input,
			{
				componentRestrictions: { country: 'au' }
			}
		)
		this.autocomplete.setFields( ['address_components', 'formatted_address'] )
		this.autocomplete.addListener( 'place_changed', this.handleGoogleAddressChange )
	}

	handleGoogleAddressChange = () => {
		let placeData = this.autocomplete.getPlace(),
			suburb,
			postcode,
			state

		placeData.address_components.map( item => {
			item.types.map( type => {
				if ( 'locality' == type ) {
					suburb = item.long_name
				}

				if ( ! suburb && 'administrative_area_level_2' == type ) {
					suburb = item.short_name
				}

				if ( ! suburb && 'political' == type ) {
					suburb = item.short_name
				}

				if ( 'postal_code' == type ) {
					postcode = item.long_name
				}

				if ( 'administrative_area_level_1' == type ) {
					state = item.short_name
				}
			} )
		} )

		const data = {
			suburb,
			postcode,
			state
		}

		this.setState( {
			value: placeData.formatted_address,
			placeData: data
		} )

		this.props.onChange( this.props.id, placeData.formatted_address, data )
	}

	handleChange = ( e ) => {
		const { placeData } = this.state

		this.setState( {
			value: e.target.value
		} )

		this.props.onChange( this.props.id, e.target.value, placeData )
	}

	render() {
		const { id, label, value, required, type, uncontrolled, note } = this.props
		let theValue = value || ''
		let className = 'form-item form-text'

		if ( uncontrolled ) {
			theValue = undefined
		}

		return (
			<div className={ className }>
				<LoadScript
					src={ `https://maps.googleapis.com/maps/api/js?libraries=places&key=${siteData.google_maps_api_key}` }
					callback={ this.handleScriptLoad }
				/>

				{ label &&
					<label htmlFor={ this.uid }>
						<span dangerouslySetInnerHTML={ { __html: label } } />

						{ required &&
							<span className="-required"> *</span>
						}
					</label>
				}

				<input type={ type } id={ this.uid } name={ id } value={ theValue } required={ required } onChange={ this.handleChange } ref={ e => this.input = e } />

				{ note &&
					<div className="form-item-note">{ note }</div>
				}
			</div>
		)
	}
}

export default Place
